/**
 * Used to validate if string is objectID or not.
 * Object ID is standard _id of MongoDB used with this platform.
 *
 * @param objectId String which we want to verify
 */
export function validateObjectId(objectId: string): boolean {
  const validator = new RegExp("^[0-9a-fA-F]{24}$");
  return validator.test(objectId);
}

/**
 * Used as fixture from unwanted malformed data in content of URI Params
 * provided by react-router
 *
 * @param param
 */
export function stripUriParamsString(param: string) {
  if (param.indexOf("?") !== -1) {
    return param.split("?")[0];
  }
  return param;
}

/**
 *
 * @param key ENV Key
 * @param value FallBack - default value
 */
export function envOrValue(key: string, value: any) {
  return process.env[key] || value;
}



// WEBPACK FOOTER //
// ./src/lib/utils/helpers.ts